const COPYRIGHT_START_YEAR = 2025;

export default function Footer() {
	const currentYear = new Date().getFullYear();
	const years =
		currentYear > COPYRIGHT_START_YEAR
			? `${COPYRIGHT_START_YEAR}-${currentYear}`
			: `${COPYRIGHT_START_YEAR}`;
	return (
		<footer className="text-sm md:text-base w-full gap-4 font-body bg-agate-900 border-t border-amber-500 py-6 px-12 flex flex-col md:flex-row md:justify-between">
			<p className="font-bold">Copyright &copy; {years} Stringiverse</p>
			<ul className="flex flex-col leading-tight sm:flex-row flex-wrap gap-1 sm:gap-4">
				<li>
					<a href="/legal/terms-and-conditions/">Terms of Service</a>
				</li>
				<li>
					<a href="/legal/privacy-policy/">Privacy Policy</a>
				</li>
				<li>
					<a href="/legal/cookie-policy/">Cookie Policy</a>
				</li>
				<li>
					<a href="/legal/eula/">EULA</a>
				</li>
				<li>
					{/* biome-ignore lint/a11y/useValidAnchor: valid */}
					<a href="#" className="termly-display-preferences">
						Consent Preferences
					</a>
				</li>
			</ul>
		</footer>
	);
}
